import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => ({
  select: {
    minWidth: theme.spacing(25),
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing(0.25),
  },
  tooltip: {
    cursor: 'pointer',
  },
  selectLabel: {
    paddingLeft: theme.spacing(1),
  },
  selectInput: {
    '&.Mui-disabled': {
      backgroundColor: 'rgba(1,1,1,0.1)',
    },
  },
  emptyTargetSystemOptions: {
    textAlign: 'center',
    padding: '15px',
  },
  alert: {
    marginTop: '15px',
    '& a': {
      cursor: 'pointer',
    },
  },
}));
